import { useCallback, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { ClientsDropdown, ProjectsDropdown } from "../DropdownV2";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SensorRefinement from "./SensorRefinement";
import InstallDetails from "./InstallationDetails";
import Kickoff from "./Kickoff";

const useStyles = makeStyles(() => ({
    appContainer: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        gap: "16px",
        padding: "0 12px",
        borderBottom: "1px solid #e0e0e0",
        flexShrink: 0,
    },
    popoverContent: {
        display: "flex",
        flexDirection: "row",
        gap: "12px",
        padding: "12px",
        minWidth: "600px",
    },
    tabContent: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        padding: "12px",
    },
}));

export default function Aspen() {
    const classes = useStyles();
    const [client, setClient] = useState("");
    const [project, setProject] = useState("");
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [buttonEl, setButtonEl] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const buttonCallbackRef = useCallback((node) => setButtonEl(node), []);

    const handleSetClient = useCallback((value) => {
        setClient(value);
        setProject("");
    }, []);

    const handleSetProject = useCallback((value) => {
        setProject(value);
        if (value) setIsPopoverOpen(false);
    }, []);

    const handleButtonClick = () => {
        setIsPopoverOpen((prev) => !prev);
    };

    const handleViewSelect = (view) => {
        setActiveView(view);
        setIsViewPopoverOpen(false);
    };

    const popoverOpen = isPopoverOpen || !project;
    const buttonLabel = client ? `${client} / ${project || "..."}` : "Select Client / Project";

    return (
        <div className={classes.appContainer}>
            <div className={classes.toolbar}>
                <Button
                    ref={buttonCallbackRef}
                    variant="outlined"
                    size="small"
                    endIcon={<KeyboardArrowDownIcon />}
                    onClick={handleButtonClick}
                >
                    {buttonLabel}
                </Button>
                <Tabs value={activeTab} onChange={(_e, val) => setActiveTab(val)}>
                    <Tab label="Kickoff" />
                    <Tab label="Sensor Placement (Map View)" />
                    <Tab label="Installation Details (List View)" />
                </Tabs>
            </div>
            <Popover
                open={popoverOpen}
                anchorEl={buttonEl}
                onClose={() => setIsPopoverOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                disableRestoreFocus
                keepMounted
                sx={{ pointerEvents: "none" }}
                PaperProps={{ sx: { pointerEvents: "auto" } }}
            >
                <div className={classes.popoverContent}>
                    <ClientsDropdown value={client} setValue={handleSetClient} styleClass={{ flex: 1 }} />
                    <ProjectsDropdown
                        clientName={client}
                        value={project}
                        setValue={handleSetProject}
                        styleClass={{ flex: 1 }}
                    />
                </div>
            </Popover>
            <div className={classes.tabContent}>
                {activeTab === 0 && <Kickoff client={client} project={project} />}
                {activeTab === 1 && <SensorRefinement client={client} project={project} />}
                {activeTab === 2 && <InstallDetails client={client} project={project} />}
            </div>
        </div>
    );
}
